import { Form, Modal } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import IBroker from '~Api/Broker/IBroker';
import { brokerPhotoIdExpiryDateAction } from '~Brokers/actions';
import DatePicker from '~UI/DatePicker';
import ModalStateEnum from '~UI/ModalStateEnum';
import { IDictionary } from '~utilities/IDictionary';

export default function PhotoIdExpiryDateModal(props: {
    broker: IBroker;
    isOpen: ModalStateEnum;
    onCancel: () => void;
}): ReactElement {
    const { isOpen, broker, onCancel } = props;
    const [dirtyFields, setDirtyFields] = useState<IDictionary<boolean>>({});
    const [expiryDate, setExpiryDate] = useState<string>(null);
    const defaultedExpiryDate: string | null = dirtyFields.expiryDate ? expiryDate : (broker.photoIdExpiryDate ?? null);

    const dispatch: Dispatch = useDispatch();

    const onChangeExpiryDate: (date: Dayjs | null) => void = useCallback((date: Dayjs | null) => {
        setExpiryDate(date ? date.format('YYYY-MM-DD') : null);
        setDirtyFields((prev: IDictionary<boolean>) => ({ ...prev, expiryDate: true }));
    }, []);

    const onClickUpdate: () => void = useCallback(() => {
        dispatch(brokerPhotoIdExpiryDateAction(broker.uuid, expiryDate));
        onCancel();
    }, [
        broker.uuid,
        dispatch,
        expiryDate,
        onCancel,
    ]);

    const onClickCancel: () => void = useCallback(() => {
        setExpiryDate(null);
        setDirtyFields({});
        onCancel();
    }, [
        onCancel,
    ]);

    return (
        <Modal
            okText='Update'
            onCancel={onClickCancel}
            onOk={onClickUpdate}
            open={ModalStateEnum.Open === isOpen}
            title='Photo ID'
            wrapClassName='broker-photo-id-modal'
        >
            <Form.Item className='expiry-date' label='Expiry Date'>
                <DatePicker onChange={onChangeExpiryDate} value={defaultedExpiryDate ? dayjs(defaultedExpiryDate) : null} format='DD/MM/YYYY' />
            </Form.Item>
        </Modal>
    );
}